import React from "react";
import { Route, Routes } from "react-router-dom";
import Routing from "./Routes";
import Toaster from "./CommonComponents/Toaster";

function App() {
  return (
    <>
      <Routes>
        <Route path="/*" element={<Routing />} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
